import App from "containers/app/App.jsx";

var indexRoutes = [{ path: "/", name: "Home", component: App }];

export default indexRoutes;
